import { CookieConstant, EmployeeStateConstant } from '../constants';
import { sessionService } from '@life-time-inc/enterprise-framework-core';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';
class EmployeeStateService implements ltFramework.IEmployeeStateService {
	public getEmployeeState(sso: string, zoneId?: string): string {
		let authenticated = false;
		if (sso) {
			authenticated = true;
		}

		let memberState = EmployeeStateConstant.unauthenticated;
		if (authenticated) {
			memberState = EmployeeStateConstant.authenticated;
		}
		else {
			sessionService.invalidate(CookieConstant.employeeDetails, zoneId);
		}

		return memberState;
	}
}

export const employeeStateService = new EmployeeStateService();
